import { render } from "./DataAbsensi.vue?vue&type=template&id=980e268e"
import script from "./DataAbsensi.vue?vue&type=script&lang=js"
export * from "./DataAbsensi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__